export default function StarSvg({
  className,
  style,
}: {
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <svg
      className={className}
      style={style}
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-1.909e-06 22.2014C19.5136 20.9333 20.5304 19.9164 21.7986 0.402826C23.0667 19.9164 24.0835 20.9333 43.5972 22.2014C24.0835 23.4696 23.0667 24.4864 21.7986 44C20.5304 24.4864 19.5136 23.4696 -1.909e-06 22.2014Z"
        fill="currentColor"
      />
    </svg>
  )
}
